// Merkezi sabitler — tüm servisler bu dosyadan içe aktarır

/** Misafir (guest) oturumunu işaret eden sabit token */
export const GUEST_TOKEN = "11771177";

/** Auth cookie adı */
export const TOKEN_COOKIE = "token";

/** Token geçerlilik süresi (gün) */
export const TOKEN_EXPIRES_DAYS = 7;
